import * as React from "react";
const SvgFiRrPlaneAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-plane-alt_svg__a)">
      <path
        fill="#062147"
        d="M10.689 24a2.688 2.688 0 0 1-2.546-3.547L10.083 15H6.158l-1.08 1.646A3 3 0 0 1 2.568 18a2.557 2.557 0 0 1-2.4-3.434L1.1 12 .159 9.44a2.56 2.56 0 0 1 .3-2.34 2.81 2.81 0 0 1 4.6.247L6.156 9h3.928L8.147 3.563a2.7 2.7 0 0 1 .359-2.442 2.883 2.883 0 0 1 4.817.442L17.58 9h3.313a3.084 3.084 0 0 1 3.067 2.5A3 3 0 0 1 21 15h-3.42l-4.267 7.454A2.99 2.99 0 0 1 10.689 24M5.618 13H11.5a1.006 1.006 0 0 1 .942 1.335l-2.41 6.773a.68.68 0 0 0 .1.605.9.9 0 0 0 1.437-.234l4.563-7.979A1 1 0 0 1 17 13h4a1 1 0 0 0 .985-1.175A1.08 1.08 0 0 0 20.893 11H17a1 1 0 0 1-.868-.5l-4.555-7.961a.894.894 0 0 0-1.447-.252.68.68 0 0 0-.093.621l2.4 6.757A1.006 1.006 0 0 1 11.5 11H5.618a1 1 0 0 1-.834-.448l-1.393-2.1c-.228-.421-1.034-.637-1.29-.21a.54.54 0 0 0-.065.51l1.072 2.906a1 1 0 0 1 0 .69l-1.066 2.91a.556.556 0 0 0 .522.742 1 1 0 0 0 .837-.452l1.376-2.1a1 1 0 0 1 .84-.448"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-plane-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPlaneAlt;
